// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-appender {\n  display: inline-block;\n  height: 30px;\n  width: 30px;\n  border: solid 1px transparent;\n  border-radius: 50%;\n  color: #555d66;\n  text-align: center;\n  cursor: pointer;\n}\n.small-appender:hover {\n  color: #3366cc;\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
